/* eslint-disable react-hooks/exhaustive-deps */
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import style from "./OrderInquirySearch.module.css";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useTranslation } from "react-i18next";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import AdminDateChoice from "routes/admin/datePicker/AdminDateChoice";
import InputText from "components/inputs/InputText";
import TestDatePicker from "components/inputs/datePicker/TestDatePicker";
import { adminRequester, requester } from "App";
import { useParams } from "react-router-dom";
import DateChoice2 from "components/inputs/datePicker/dateChoice/DateChoice2";
import CheckBox from "components/inputs/checkBox/CheckBox";
import { Radio, RadioGroup } from "@mui/material";

export const Searches = [
  {
    name: "제목",
    value: "title",
  },
  {
    name: "내용",
    value: "content",
  },
  { name: "재목+내용", value: "text" },
  { name: "작성자", value: "who" },
  { name: "게시글ID", value: "id" },
  { name: "주문ID", value: "order_id" },
  { name: "상품ID", value: "product_id" },
  { name: "옵션ID", value: "variant_id" },
];
// export const Types = [
//   { name: "전체", value: "all" },
//   { name: "공지", value: "notification" },
//   { name: "QnA", value: "QnA" },
//   { name: "리뷰", value: "review" },
// ];
export const Statuses = [
  { name: "전체", value: "all" },
  { name: "무제한", value: "infinite" },
  {
    name: "예정",
    value: "ready",
  },
  {
    name: "진행중",
    value: "continue",
  },
  {
    name: "종료",
    value: "end",
  },
];
export const Views = [
  { name: "전체", value: "all" },
  { name: "일반글", value: "active" },
  { name: "비밀글", value: "hidden" },
];
const ArticleInquirySearch = forwardRef((props, ref) => {
  const { reset, setReset, research } = props;
  // const { isMobile } = useContext(BrowserDetectContext);
  const [reload, setReload] = useState(false);
  const [isMounted, setMounted] = useState(false);
  const [types, setTypes] = useState([]);
  const [type, setType] = useState("all");
  const [search, setSearch] = useState(Searches[0].value);
  const [status, setStatus] = useState(Statuses[0].value);
  const [view, setView] = useState(Views[0].value);

  const startInit = new Date();
  startInit.setHours(0, 0, 0, 0);
  startInit.setDate(startInit.getDate() - 7);
  const endInit = new Date();
  endInit.setHours(23, 59, 59, 999);

  const [startDate, setStartDate] = useState(startInit);
  const [endDate, setsEndDate] = useState(endInit);

  const { t } = useTranslation();

  const dateRef = useRef();
  const input = useRef();

  //   const koreaTimeDiff = 9 * 60; // 한국은 UTC+9

  const maxDate = new Date();

  maxDate.setFullYear(maxDate.getFullYear() + 10);

  const onSearchClick = () => {
    let data = {};
    let startDateStr = dateRef.current.getStartDate().getTime();
    let endDateStr = dateRef.current.getEndDate().getTime();
    data.startDate = startDateStr;
    data.endDate = endDateStr;
    data.search = search;
    data.active = status;
    data.input = input.current.getValue();
    data.type = type;
    data.view = view;
    data.status = "table";
    // data.expand = "payments,customer,items.variant";
    // data.purchaseOrderId = inputs.current[0].getValue();
    // data.userName = inputs.current[1].getValue();
    // data.name = inputs.current[2].getValue();
    props.callback && props.callback(data);
  };
  const onInitializationClick = () => {
    input.current.setValue("");
    setStartDate(startInit);
    setsEndDate(endInit);
    setType("all");
    setSearch(Searches[0].value);
    setStatus(Statuses[0].value);
    setView(Views[0].value);
    dateRef.current.setActive([false, false, false, false, false]);
    setReload(true);
  };
  useEffect(() => {
    if (reload) {
      setReload(false);
      onSearchClick();
    }
  }, [reload]);

  const searchStyle = {
    backgroundColor: "var(--admin-main-color)",
    padding: "7px 20px",
    border: "1px solid #ddd",
  };

  const initializationStyle = {
    backgroundColor: "white",
    padding: "7px 20px",
    color: "black",
    border: "1px solid #ddd",
  };

  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      input.current.focus();
      adminRequester.getBoards({}, ({ boards }) =>
        setTypes([...new Set(boards.map((board) => board.name))])
      );
      onInitializationClick();
    }
  }, [isMounted]);
  useEffect(() => {
    if (reset) {
      onInitializationClick();
      setReset(false);
    }
  }, [reset]);
  useEffect(() => {
    if (research) onSearchClick();
  }, [research]);
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    생성일
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10}>
                <FlexChild width={"max-content"}>
                  {/* <TestDatePicker ref={dateRef} startDate={startDate} endDate={endDate} maxDate={maxDate} /> */}
                  <DateChoice2
                    ref={dateRef}
                    startDate={startDate}
                    endDate={endDate}
                    maxDate={maxDate}
                  />
                </FlexChild>
                <FlexChild />
              </HorizontalFlex>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent={"flex-start"}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    게시글 종류
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild width={"max-content"}>
              <select
                className={style.select}
                onChange={(e) => setType(e.target.value)}
                value={type}
              >
                <option value={"all"}>{t("전체")}</option>
                {types?.map((type, index) => (
                  <option key={`type_${index}`} value={type}>
                    {t(type)}
                  </option>
                ))}
              </select>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent={"flex-start"}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    기간제한
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild width={"max-content"}>
              <RadioGroup
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                  {Statuses?.map((status) => (
                    <FlexChild width={"max-content"}>
                      <Radio name="publishStatus" value={status.value} />
                      <P size={15} color={"#aaa"}>
                        {status.name}
                      </P>
                    </FlexChild>
                  ))}
                </HorizontalFlex>
              </RadioGroup>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent={"flex-start"}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    게시글상태
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild width={"max-content"}>
              <RadioGroup
                value={view}
                onChange={(e) => setView(e.target.value)}
              >
                <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                  {Views?.map((view) => (
                    <FlexChild width={"max-content"}>
                      <Radio name="viewStatus" value={view.value} />
                      <P size={15} color={"#aaa"}>
                        {view.name}
                      </P>
                    </FlexChild>
                  ))}
                </HorizontalFlex>
              </RadioGroup>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent={"flex-start"}>
            <FlexChild
              width={"10%"}
              backgroundColor={"var(--admin-table-bg-color)"}
            >
              <div className={style.titleWrap}>
                <Center>
                  <P size={15} weight={"bold"}>
                    검색조건
                  </P>
                </Center>
              </div>
            </FlexChild>
            <FlexChild width={"max-content"}>
              <HorizontalFlex gap={25}>
                <FlexChild width="120px">
                  <select
                    className={style.select}
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                  >
                    {Searches?.map((search, index) => (
                      <option key={`search_${index}`} value={search.value}>
                        {search.name}
                      </option>
                    ))}
                  </select>
                </FlexChild>
                <FlexChild width={300} paddingLeft={10}>
                  <InputText
                    ref={(el) => (input.current = el)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") onSearchClick();
                    }}
                  />
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild backgroundColor={"#f5f6fb"} padding={"15px 0"}>
          <HorizontalFlex gap={20}>
            <FlexChild justifyContent={"flex-end"}>
              <CustomButton
                text={"조건검색"}
                style={searchStyle}
                onClick={onSearchClick}
              />
            </FlexChild>
            <FlexChild>
              <CustomButton
                text={"초기화"}
                style={initializationStyle}
                onClick={() => setReset(true)}
              />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
});

export default ArticleInquirySearch;
